import { Reducer, Action } from "redux";
import { IMonitoringState, KnownAction, SHOW_UPDATING_ADDITIONAL_INFO_LOADER } from "./types";

export const reducer: Reducer<IMonitoringState> = (state: IMonitoringState | undefined, incomingAction: Action): IMonitoringState => {
    if (state === undefined) {
        return { isLoading: false, isUpdatingAdditionalInfo: false };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case SHOW_UPDATING_ADDITIONAL_INFO_LOADER:
            return {
                ...state,
                isUpdatingAdditionalInfo: action.isUpdatingAdditionalInfo,
            };
        default:
            return state;
    }
};
